import React, { useState, useEffect } from 'react';
import { FaComments, FaArrowLeft } from 'react-icons/fa';
import ChatLogList from './ChatLogview/ChatLogList';
import ChatLogDetail from './ChatLogview/ChatLogDetail';
import MasterDashboard from './Dashboard/Dashboard';

const Home = () => {
  const [activeTab, setActiveTab] = useState('view');
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [showMobileDetail, setShowMobileDetail] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    recentLogs: false,
    fromDate: '',
    toDate: '',
    status: 'all',
    limit: 50, // Default limit
  });
  const [showDashboard, setShowDashboard] = useState(false);

  useEffect(() => {
    if (showDashboard) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showDashboard]);

  const handleSelectLog = (log) => {
    setSelectedLog(log);
    if (window.innerWidth < 1024) {
      setShowMobileDetail(true);
    }
  };

  const handleBackToList = () => {
    setShowMobileDetail(false);
    setSelectedLog(null);
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };
  const clearFilters = () => {
    setFilters({
      search: '',
      recentLogs: false,
      fromDate: '',
      toDate: '',
      status: 'all',
      limit: 50, // Reset to default limit
    });
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-pl_bg_light_5 to-pl_bg_light_3">
      <div className="w-full min-h-screen bg-pl_bg_light_3 shadow-lg">
        {/* Tab Content */}
        <div className="w-full min-h-screen">
          {showDashboard ? (
            <div className="relative min-h-[calc(100vh-80px)] sm:min-h-[calc(100vh-120px)]">
              <button
                onClick={() => setShowDashboard(false)}
                className="fixed bottom-20 sm:bottom-28 right-4 sm:right-6 z-50 bg-pl_txt_light_2 text-pl_bg_light_3 px-3 py-2 sm:px-4 sm:py-2 rounded-25 shadow-lg hover:bg-pl_txt_light_1 transition-all text-sm sm:text-base font-semibold"
              >
                Close Dashboard
              </button>
              <MasterDashboard />
            </div>
          ) : (
            activeTab === 'view' && (
              <div className="flex flex-col lg:flex-row h-[calc(100vh)] sm:h-[calc(100vh)]">
                {/* Left Panel: Chat Log List */}
                <div className={`w-full relative bg-pl_bg_light_3 border-b lg:border-b-0 lg:border-r border-pl_border_light_1 flex-shrink-0 ${
                  showMobileDetail ? 'hidden lg:block lg:w-80' : 'block lg:w-80'
                }`}>
                  <ChatLogList
                    onSelect={handleSelectLog}
                    filters={filters}
                    onFilterChange={handleFilterChange}
                    onClearFilters={clearFilters}
                  />
                </div>
                {/* Right Panel: Chat Log Detail */}
                <div className={`flex-1 bg-pl_bg_light_3 relative ${
                  showMobileDetail ? 'block' : 'hidden lg:block'
                }`}>
                  {showMobileDetail && (
                    <div className="sticky top-0 z-20 bg-pl_bg_light_3 border-b border-pl_border_light_1 lg:hidden">
                      <button
                        onClick={handleBackToList}
                        className="flex items-center gap-2 px-4 py-3 text-pl_prim_color_1 hover:text-pl_prim_color_3 hover:bg-pl_bg_light_5 transition-all duration-200 font-medium text-sm sm:text-base"
                      >
                        <FaArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                        <span>Back to List</span>
                      </button>
                    </div>
                  )}
                  <ChatLogDetail log={selectedLog} />
                </div>
              </div>
            )
          )}
        </div>
        {/* Floating Dashboard Button */}
        {!showDashboard && (
          <button
            className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 bg-gradient-to-br from-pl_prim_color_1 via-pl_prim_color_2 to-pl_prim_color_3 text-pl_bg_light_3 px-4 py-2 sm:px-6 sm:py-3 rounded-25 shadow-lg hover:from-pl_prim_color_3 hover:via-pl_prim_color_2 hover:to-pl_prim_color_1 transition-all text-sm sm:text-lg font-semibold flex items-center gap-1 sm:gap-2"
            onClick={() => setShowDashboard(true)}
          >
            <FaComments className="w-4 h-4 sm:w-6 sm:h-6" />
            <span className="hidden sm:inline">Dashboard</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Home;
